<template>
  <div class="plan">
    <div class="title">{{ title }}</div>
    <div class="content" :class="{'contentThree': list.length==3}">
      <div class="list" v-for="item of list" :key="item">
        <img :src="item.img" alt="" />
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '主要功能模块'
    },
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  data: function() {
    return {
      data: {
        menu_list: []
      },
      plan: [
        {
          title: '学校管理',
          desc: '',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/6.png'
        },
        {
          title: '代理商管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/7.png'
        },
        {
          title: '资源管理',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/8.png'
        },
        {
          title: '数据分析',
          img:
            'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/dian/9.png'
        }
      ],
    };
  },
  created() {},
  methods: {
    go() {
      this.$router.push({
        name: 'eg'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.plan {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding-top: 1px;
  .title {
    font-size: 42px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.6);
    line-height: 63px;
    text-align: center;
    margin-top: 87px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 36px;
    margin-top: 30px;
    .list {
      width: auto;
      flex: 1;
      img {
        width: 241px;
        height: 241px;
        border-radius: 20px;
        margin: 0 auto;
        display: block;
      }
      .title{
        text-align: center;
        font-size: 26px;
        font-weight: 400;
        color: #5E5E5E;
        line-height: 40px;
        margin-top: 20px;
      }
      .desc {
        text-align: justify;
        font-size: 18px;
        color: #5E5E5E;
        line-height: 24px;
        margin: 0 auto;
        margin-top: 10px;
        width: 264px;
      }
    }
  }
}
@media (max-width: 1000px) {
  .plan{
    width: 100%;
    > .title{
      font-size: 44px;
      margin-top: 80px;
      margin-bottom: 80px;
    }
    .content{
      flex-wrap: wrap;
      padding: 0 48px;
      .list{
        width: 300px;
        margin-bottom: 100px;
        flex: none;
        img{
          width: 100%;
          height: 300px;
        }
        .title{
          font-size: 36px;
          margin-top: 40px;
          color: #5E5E5E;
        }
        .desc{
          font-size: 28px;
          line-height: 1.3;
          margin-top: 20px;
          text-align: justify;
          width: 280px;
        }
      }
      
    }
    .contentThree{
      padding-bottom: 20px;
      .list{
        width: 100%;
        height: 240px;
        position: relative;
        padding-left: 288px;
        margin-bottom: 80px;
        img{
          width: 240px;
          height: 240px;
          position: absolute;
          left: 0;
          top: 0;
        }
        .title{
          text-align: left;
          margin-top: 28px;
        }
        .desc{
          margin-top: 20px;
          width: 366px;
        }
      }
    }
  }
}
</style>
